<ng-container *ngIf="sharedDataState$ | async as sharedDataState">
    <div class="mat-elevation-z3">
        <table mat-table [dataSource]="datasource">


            <ng-container matColumnDef="articleNr">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.production.articleNr.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.articleNr }}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.production.name.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.costUnitId != null && sharedDataState.costUnitLookup[element.costUnitId]; else byProductName">
                        {{ sharedDataState.costUnitLookup[element.costUnitId].name }}
                    </ng-container>

                    <ng-template #byProductName>
                        <ng-container *ngIf="element.articleId != null && sharedDataState.articleLookup[element.articleId]; else displayPlaceholder">
                            {{ sharedDataState.articleLookup[element.articleId].name }}
                        </ng-container>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="measureUnit">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.production.measureUnit.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.measureUnitId != null && sharedDataState.measureUnitLookup[element.measureUnitId]; else displayPlaceholder">
                        {{ sharedDataState.measureUnitLookup[element.measureUnitId].shortName }}
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.production.amount.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.amount | number: '1.2-2' : 'de-DE' }}
                </td>
            </ng-container>

            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.production.price.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.purchasePriceCt !== null; else placeHolder">
                        {{ element.purchasePriceCt / 100 | currency:'EUR':'symbol':'1.2-2' }}
                    </ng-container>
                    <ng-template #placeHolder>-</ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ "app.model.production.type.label" | translate }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.costUnitId != null; else byProduct">
                        <mat-icon>check</mat-icon>
                    </ng-container>
                    <ng-template #byProduct>
                        <mat-icon style="color: gray">close</mat-icon>
                    </ng-template>
                </td>
            </ng-container>


            <ng-template #displayPlaceholder>-</ng-template>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        </table>
    </div>
</ng-container>
